module.exports = __webpack_public_path__ + "static/media/Suicune_gaussian2.e27ff132.png";